

































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { NotificationModule } from '@/app/store/modules/notifications'
import { MasterModule } from '@/app/store/modules/master'

import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import {
  required,
  minLength,
  maxLength,
  not,
  sameAs,
} from 'vuelidate/lib/validators'
import { TouchSwipe } from 'quasar'

@Component
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public isDisabled
  @Prop({}) public idModal
  @Prop({}) public resetModalAdd

  public MaterialId: string = ''
  public condition: boolean = false
  @Validate({
    required,
  })
  public Url: string = ''
  @Validate({
    required,
  })
  public Material: string = ''

  public byTrainingMaterial(text) {
    this.Url = ''
    this.$v.Url.$reset()
    const find = this.TrainingOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.TrainingOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getTrainingMaterialSpesial()
    }
    const a = text.split('/')[1]
    if (this.TrainingOptions.length > 0 && text.length >= 3) {
      this.MaterialId =
        this.TrainingOptions.find((e) => e.id === Number(a)).id || ''
      this.Url = this.TrainingOptions.find((e) => e.id === Number(a)).url
    }
  }
  public TrainingOptions: any = []
  public get TrainingMaterial() {
    this.TrainingOptions = MasterModule.TrainingMaterialData.data
    return MasterModule.TrainingMaterialData
  }

  public clearfile() {
    this.materialType = ''
    this.Material = ''
    this.Url = ''
    this.hasFiles = {
      file_name: '',
      file_byte: '',
      file_upload: null,
    }
  }

  public byGuideMaterial(text) {
    this.Url = ''
    this.$v.Url.$reset()
    const find = this.GuideOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.GuideOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getGuideMaterial()
    }
    const a = text.split('/')[1]
    if (this.GuideOptions.length > 0 && text.length >= 3) {
      this.MaterialId =
        this.GuideOptions.find((e) => e.id === Number(a)).id || ''
      this.Url = this.GuideOptions.find((e) => e.id === Number(a)).url || ''
    }
  }
  public GuideOptions: any = []
  public get GuideMaterial() {
    this.GuideOptions = MasterModule.GuideMaterialData.data
    return MasterModule.GuideMaterialData
  }

  public validateExternalLink(text) {
      const link = this.link.trim();

      // Regex untuk validasi dasar URL email
      const urlRegex = /^.+\.[a-z]{2,}(?:\/[^\s]*)?$/i;
      if(link === ''){
        this.validationResult = {
          isValid: false,
          message: 'This is a required field',
        };
      }
      else if (link.startsWith('https://')) {
        this.validationResult = {
          isValid: false,
          message: 'Link tidak harus dimulai dengan https://',
      };
      } else if (!urlRegex.test(link)) {
        this.validationResult = {
          isValid: false,
          message: 'Format link tidak sesuai',
        };
      } else {
        this.validationResult = {
          isValid: true,
          message: 'Link valid',
        };
      }
    }

  public byInfoMaterial(text) {
    this.Url = ''
    this.$v.Url.$reset()
    const find = this.InfoOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.InfoOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getInfoMaterial()
    }
    const a = text.split('/')[1]
    if (this.InfoOptions.length > 0 && text.length >= 3) {
      this.MaterialId =
        this.InfoOptions.find((e) => e.id === Number(a)).id || ''
      this.Url = this.InfoOptions.find((e) => e.id === Number(a)).url || ''
    }
  }
  public InfoOptions: any = []
  public get InfoMaterial() {
    this.InfoOptions = MasterModule.InfoMaterialData.data
    return MasterModule.InfoMaterialData
  }

  public byBulletinMaterial(text) {
    this.Url = ''
    this.$v.Url.$reset()
    const find = this.BulletinOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.BulletinOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getBulletinMaterial()
    }
    const a = text.split('/')[1]
    if (this.BulletinOptions.length > 0 && text.length >= 3) {
      this.MaterialId =
        this.BulletinOptions.find((e) => e.id === Number(a)).id || ''
      this.Url = this.BulletinOptions.find((e) => e.id === Number(a)).url || ''
    }
  }
  public BulletinOptions: any = []
  public get BulletinMaterial() {
    this.BulletinOptions = MasterModule.BulletinMaterialData.data
    return MasterModule.BulletinMaterialData
  }

  @Validate({
    required,
  })
  public byPosition3: any = ['All']
  public byPosition5: any = []
  public byPosition2: string = ''
  public byPosition4: string = 'All'
  public byPositionOld: string = ''
  @Validate({
    required,
    minLength: minLength(3),
    maxLength: maxLength(255),
  })
  public byPosition: string = 'All'

  @Validate({
    required,
  })
  public byGroup3: any = ['All']
  public byGroup2: string = ''
  public byGroup4: string = 'All'
  @Validate({
    required,
    minLength: minLength(3),
    maxLength: maxLength(255),
  })
  public byGroup: string = 'All'

  @Validate({
    required,
  })
  public byCity3: any = ['All']
  public byCity2: string = ''
  public byCity4: string = 'All'
  @Validate({
    required,
    minLength: minLength(3),
    maxLength: maxLength(255),
  })
  public byCity: string = 'All'

  @Validate({
    required,
  })
  public byDealerCode3: any = ['All']
  public byDealerCode2: string = ''
  public byDealerCode4: string = 'All'
  @Validate({
    required,
    minLength: minLength(3),
    maxLength: maxLength(255),
  })
  public byDealerCode: string = 'All'

  @Validate({
    required,
  })
  public byDealerName3: any = ['All']
  public byDealerName2: string = ''
  public byDealerName4: string = 'All'
  @Validate({
    required,
    minLength: minLength(3),
    maxLength: maxLength(255),
  })
  public byDealerName: string = 'All'

  @Validate({
    required,
  })
  public byDealerArea3: any = ['All']
  public byDealerArea2: string = ''
  public byDealerArea: string = 'All'
  public byDealerArea4: string = 'All'

  @Validate({
    required,
  })
  public byTeam3: any = ['All']
  public byTeam2: string = ''
  public byTeam: string = 'All'
  public byTeam4: string = 'All'

  @Watch('resetModalAdd')
  public onPropertyChanged(value: boolean, oldValue: boolean) {
    this.$v.ownerType.$reset()
    this.$v.uploadType.$reset()
  }

  // @Watch("byPosition2")
  // public onPosition2Changed(value: string, oldValue: string) {
  //   this.byPosition = this.byPosition2;
  // }

  // @Watch("byPosition")
  // public onPositionChanged(value: string, oldValue: string) {
  //   if (this.byPosition.length >= 3) {
  //     MasterModule.paginationParam.search = this.byPosition;
  //     MasterModule.getPosition();
  //   }
  // }

  @Watch('byPosition3')
  public onPosition3Changed(value: string, oldValue: string) {
    // console.log('Data dari old' + oldValue)
    this.byPositionOld = oldValue
    // console.log('Data dari posisi' + this.byPositionOld)
    if (this.byPositionOld.toString() === 'All') {
      const index = this.byPosition3.indexOf('All')
      this.byPosition3.splice(index, 1)
      // console.log('data masuk splice' + index)
    }
    this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
    this.byPosition4 = this.byPosition
    // console.log('data masuk sesuadah di bersihni' + this.byPosition3)
    if (this.byPosition === '') {
      this.byPosition3 = ['All']
    }
    // this.byPosition2 = "";
  }
  public positions: any = []
  public get positionData() {
    this.positions = MasterModule.PositionData.data
    return MasterModule.PositionData
  }

  @Watch('byCity2')
  public onCity2Changed(value: string, oldValue: string) {
    this.byCity = this.byCity2
  }

  @Watch('byCity')
  public onCityChanged(value: string, oldValue: string) {
    if (this.byCity.length >= 3) {
      MasterModule.paginationParam.search = this.byCity
      MasterModule.getCity()
    }
  }
  public cities: any = []
  public get cityData() {
    this.cities = MasterModule.MasterData.data
    return MasterModule.MasterData
  }

  @Watch('byGroup2')
  public onDealerGroup2Changed(value: string, oldValue: string) {
    this.byGroup = this.byGroup2
  }

  @Watch('byGroup')
  public onDealerGroupChanged(value: string, oldValue: string) {
    if (this.byGroup.length >= 0) {
      MasterModule.paginationParam.search = this.byGroup
      MasterModule.getDealerGroup()
    }
  }
  public dealerGroup: any = []
  public get dealerGroupData() {
    this.dealerGroup = MasterModule.DealerGroupData.data
    return MasterModule.DealerGroupData
  }

  @Watch('byDealerCode2')
  public byDealerCode2Changed(value: string, oldValue: string) {
    this.byDealerCode = this.byDealerCode2
  }

  @Watch('byDealerCode')
  public byDealerCodeChanged() {
    if (this.byDealerCode.length >= 3) {
      MasterModule.paginationParam.search = this.byDealerCode
      MasterModule.getDealerName()
    }
  }
  public dealerCodeOptions: any = []

  public get dealerCode() {
    this.dealerCodeOptions = MasterModule.DealerNameData.data
    return MasterModule.DealerNameData
  }

  @Watch('byDealerName2')
  public byDealerName2Changed(value: string, oldValue: string) {
    this.byDealerName = this.byDealerName2
  }

  @Watch('byDealerName')
  public byDealerNameChanged(text) {
    if (text.length >= 3) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerName()
    }
  }
  public dealerNameOptions: any = []
  public get dealerNameCode() {
    this.dealerNameOptions = MasterModule.DealerNameData.data
    return MasterModule.DealerNameData
  }

  public items: any = [
    'All',
    'Salesman',
    'Salesman Counter',
    'Branch Manager',
    'Sales Manager',
    'Supervisor',
  ]

  public dealerAreaOptions: any = [
    {
      value: 'All',
      text: 'All',
    },
    {
      value: 'KALIMANTAN & IBT',
      text: 'KALIMANTAN & IBT',
    },
    {
      value: 'JABODETABEK',
      text: 'JABODETABEK',
    },
    {
      value: 'WEST JAVA',
      text: 'WEST JAVA',
    },
    {
      value: 'CENTRAL JAVA',
      text: 'CENTRAL JAVA',
    },
    {
      value: 'EAST JAVA',
      text: 'EAST JAVA',
    },
    {
      value: 'SUMATERA',
      text: 'SUMATERA',
    },
  ]

  public teamOptions: any = [
    {
      value: 'All',
      text: 'All',
    },
    {
      value: 'PC',
      text: 'PC',
    },
    {
      value: 'LCV',
      text: 'LCV',
    },
  ]

  public $v: Vuelidate
  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
  })
  public title: string = ''

  @Validate({
    required,
    maxLength: maxLength(255),
  })
  public link: string = ''
  public validationResult: any = {
    isValid: false,
    message: '',
  }

  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(500),
  })
  public message: string = ''

  @Validate({
    required,
  })
  public uploadType = ''
  public uploadOptions: any = [
    {
      value: '',
      text: 'Select type upload',
    },
    {
      value: 'Non-Material',
      text: 'Non-Material',
    },
    {
      value: 'Material',
      text: 'Material',
    },
    {
      value: 'External-Link',
      text: 'External Link',
    },
  ]

  @Validate({
    required,
  })
  public ownerType = ''
  public ownerOptions: any = [
    {
      value: '',
      text: 'Select Owner',
    },
    {
      value: 'User',
      text: 'User',
    },
    {
      value: 'Topic',
      text: 'Topic',
    },
  ]
  @Validate({
    required,
  })
  public materialType = ''
  public materialOptions: any = [
    {
      value: '',
      text: 'Select material type',
    },
    {
      value: 'bulletin',
      text: 'Bulletin',
    },
    {
      value: 'training',
      text: 'Training',
    },
    {
      value: 'info',
      text: 'Additional Info',
    },
    {
      value: 'sop',
      text: 'SOP',
    },
  ]
  // has select owner User
  @Validate({
    required,
    minLength: minLength(1),
    maxLength: maxLength(255),
  })
  public ownerUser: any = []

  // has select owner topic
  public ownerTopic: any = [
    {
      position: 'All',
      Group: 'All',
      city: 'All',
      dealercode: 'All',
      dealername: 'All',
      dealerarea: 'All',
      team: 'All',
    },
  ]

  // input file
  public hasFiles = {
    file_name: '',
    file_byte: '',
    file_upload: null,
  }

  // convert PDF Base 64
  public base64Pdf(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        const hash = e.target.result.split(',')
        this.hasFiles = {
          file_name: input.files[0].name,
          file_byte: hash.length ? hash[1] : '',
          file_upload: input.files[0],
        }
      }
      reader.readAsDataURL(input.files[0])
    }
  }
  public onRemovePosition(data) {
    const index = this.byPosition3.indexOf(data)
    // console.log('data yang diremove' + data + ' ' + index)
    this.byPosition3.splice(index, 1)
    this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
    this.byPosition4 = this.byPosition
    if (this.byPosition3.length === 0) {
      this.byPosition3.push('All')
      this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
      this.byPosition4 = this.byPosition
      this.byPosition2 = ''
    }
  }
  public onRemoveGroup(data) {
    const index = this.byGroup3.indexOf(data)
    this.byGroup3.splice(index, 1)
    this.byGroup = this.byGroup3.join(',').replace(/\s/g, '')
    this.byGroup4 = this.byGroup
    if (this.byGroup3.length === 0) {
      this.byGroup3.push('All')
      this.byGroup = this.byGroup3.join(',').replace(/\s/g, '')
      this.byGroup4 = this.byGroup
      this.byGroup2 = ''
    }
  }
  public onRemoveDelerCode(data) {
    const index = this.byDealerCode3.indexOf(data)
    this.byDealerCode3.splice(index, 1)
    this.byDealerCode = this.byDealerCode3.join(',').replace(/\s/g, '')
    this.byDealerCode4 = this.byDealerCode
    if (this.byDealerCode3.length === 0) {
      this.byDealerCode3.push('All')
      this.byDealerCode = this.byDealerCode3.join(',').replace(/\s/g, '')
      this.byDealerCode4 = this.byDealerCode
      this.byDealerCode2 = ''
    }
  }
  public onRemoveDelerName(data) {
    const index = this.byDealerName3.indexOf(data)
    this.byDealerName3.splice(index, 1)
    this.byDealerName = this.byDealerName3.join(';').replace(/\s/g, '')
    this.byDealerName4 = this.byDealerName
    if (this.byDealerName3.length === 0) {
      this.byDealerName3.push('All')
      this.byDealerName = this.byDealerName3.join(';').replace(/\s/g, '')
      this.byDealerName4 = this.byDealerName
      this.byDealerName2 = ''
    }
  }
  public onRemoveDelerArea(data) {
    const index = this.byDealerArea3.indexOf(data)
    this.byDealerArea3.splice(index, 1)
    this.byDealerArea = this.byDealerArea3.join(',').replace(/\s/g, '')
    this.byDealerArea4 = this.byDealerArea
    if (this.byDealerArea3.length === 0) {
      this.byDealerArea3.push('All')
      this.byDealerArea = this.byDealerArea3.join(',').replace(/\s/g, '')
      this.byDealerArea4 = this.byDealerArea
      this.byDealerArea2 = ''
    }
  }
  public onRemoveCity(data) {
    const index = this.byCity3.indexOf(data)
    this.byCity3.splice(index, 1)
    this.byCity = this.byCity3.join(',').replace(/\s/g, '')
    this.byCity4 = this.byCity
    if (this.byCity3.length === 0) {
      this.byCity3.push('All')
      this.byCity = this.byCity3.join(',').replace(/\s/g, '')
      this.byCity4 = this.byCity
      this.byCity2 = ''
    }
  }
  public onRemoveTeam(data) {
    const index = this.byTeam3.indexOf(data)
    this.byTeam3.splice(index, 1)
    this.byTeam = this.byTeam3.join(',').replace(/\s/g, '')
    this.byTeam4 = this.byTeam
    if (this.byTeam3.length === 0) {
      this.byTeam3.push('All')
      this.byTeam = this.byTeam3.join(',').replace(/\s/g, '')
      this.byTeam4 = this.byTeam
      this.byTeam2 = ''
    }
  }
  // public onOptionClickPosition(data) {
  //   this.byPosition3.push(data);
  //   this.byPosition = this.byPosition3.join(",").replace(/\s/g, "");
  //   this.byPosition4 = this.byPosition;
  //   this.byPosition2 = "";
  // }
  public onOptionClickGroup(data) {
    this.byGroup3.push(data)
    const index = this.byGroup3.indexOf('All')
    if (index === 0) {
      this.byGroup3.splice(index, 1)
    }
    this.byGroup = this.byGroup3.join(',').replace(/\s/g, '')
    this.byGroup4 = this.byGroup
    this.byGroup2 = ''
  }
  public onOptionClickCode(data) {
    this.byDealerCode3.push(data)
    const index = this.byDealerCode3.indexOf('All')
    if (index === 0) {
      this.byDealerCode3.splice(index, 1)
    }
    this.byDealerCode = this.byDealerCode3.join(',').replace(/\s/g, '')
    this.byDealerCode4 = this.byDealerCode
    this.byDealerCode2 = ''
  }

  public onOptionClickName(data) {
    this.byDealerName3.push(data)
    const index = this.byDealerName3.indexOf('All')
    if (index === 0) {
      this.byDealerName3.splice(index, 1)
    }
    this.byDealerName = this.byDealerName3.join(';').replace(/\s/g, '')
    this.byDealerName4 = this.byDealerName
    // console.log('this.byDealerName4' + this.byDealerName)
    this.byDealerName2 = ''
  }
  public onOptionClickArea(data) {
    this.byDealerArea3.push(data)
    const index = this.byDealerArea3.indexOf('All')
    if (index === 0) {
      this.byDealerArea3.splice(index, 1)
    }
    this.byDealerArea = this.byDealerArea3.join(',').replace(/\s/g, '')
    this.byDealerArea4 = this.byDealerArea
    this.byDealerArea2 = ''
  }
  public onOptionClickCity(data) {
    this.byCity3.push(data)
    const index = this.byCity3.indexOf('All')
    if (index === 0) {
      this.byCity3.splice(index, 1)
    }
    this.byCity = this.byCity3.join(',').replace(/\s/g, '')
    this.byCity4 = this.byCity
    this.byCity2 = ''
  }
  public onOptionClickTeam(data) {
    this.byTeam3.push(data)
    const index = this.byTeam3.indexOf('All')
    if (index === 0) {
      this.byTeam3.splice(index, 1)
    }
    this.byTeam = this.byTeam3.join(',').replace(/\s/g, '')
    this.byTeam4 = this.byTeam
    this.byTeam2 = ''
  }

  public posCount: number = 0
  public groupCount: number = 0
  public cityCount: number = 0
  public codeCount: number = 0
  public nameCount: number = 0
  public teamCount: number = 0
  public areaCount: number = 0
  public max: number = 0
  public sub: number = 0
  public arr: string[] = []
  // checkbox deletable
  public deletable: string = 'false'
  // get Owner Id type
  public get ownerId(): any {
    let i = 0
    let j = 0
    let k = 0
    let l = 0
    let m = 0
    let n = 0
    let o = 0
    const p = 0
    let variabel = ''
    this.posCount = this.byPosition4.toString().split(',').length
    this.groupCount = this.byGroup.toString().split(',').length
    this.cityCount = this.byCity.toString().split(',').length
    this.areaCount = this.byDealerArea.toString().split(',').length
    this.codeCount = this.byDealerCode.toString().split(',').length
    this.teamCount = this.byTeam.toString().split(',').length
    this.nameCount = this.byDealerName.toString().split(';').length
    this.max = Math.max(
      this.posCount,
      this.groupCount,
      this.cityCount,
      this.areaCount,
      this.codeCount,
      this.teamCount,
      this.nameCount
    )
    for (i = 0; i < this.posCount; i++) {
      for (j = 0; j < this.groupCount; j++) {
        for (k = 0; k < this.cityCount; k++) {
          for (l = 0; l < this.codeCount; l++) {
            for (m = 0; m < this.nameCount; m++) {
              for (n = 0; n < this.areaCount; n++) {
                for (o = 0; o < this.teamCount; o++) {
                  ;(variabel =
                    this.byPosition4
                      .toString()
                      .split(',')
                    [i].toLowerCase()
                      .split(' ')
                      .join('') +
                    '-' +
                    this.byGroup4
                      .toString()
                      .split(',')
                    [j].toLowerCase()
                      .split(' ')
                      .join('') +
                    '-' +
                    this.byCity4
                      .toString()
                      .split(',')
                    [k].toLowerCase()
                      .split(' ')
                      .join('') +
                    '-' +
                    this.byDealerCode4
                      .toString()
                      .split(',')
                    [l].toLowerCase()
                      .split(' ')
                      .join('') +
                    '-' +
                    this.byDealerName4
                      .toString()
                      .split(';')
                    [m].toLowerCase()
                      .replace(/[^a-z0-9]/gi, '')
                      .split(' ')
                      .join('')
                      .split(',')
                      .join('') +
                    '-' +
                    this.byDealerArea4
                      .toString()
                      .split(',')
                    [n].toLowerCase()
                      .split(' ')
                      .join('') +
                    '-' +
                    this.byTeam4
                      .toString()
                      .split(',')
                    [o].toLowerCase()),
                    this.arr.push(variabel)
                }
              }
            }
          }
        }
      }
    }
    return this.ownerType === 'User' ? this.ownerUser : this.arr
  }

  // post data notif
  public postNotif(item, index, button) {
    this.$v.byPosition3.$touch()
    this.$v.byCity3.$touch()
    this.$v.byGroup3.$touch()
    this.$v.byDealerCode3.$touch()
    this.$v.byDealerName3.$touch()
    this.$v.title.$touch()
    this.$v.message.$touch()
    this.$v.materialType.$touch()
    this.$v.uploadType.$touch()
    this.$v.ownerType.$touch()
    this.$v.Material.$touch()
    this.$v.Url.$touch()
    this.$v.ownerUser.$touch()
    let NotificationTypeInt = '0';
    let EncodeLink = '';
    if (this.uploadType === 'Non-Material') {
      NotificationTypeInt = '1';
    }
    else if (this.uploadType === 'Material') {
      NotificationTypeInt = '2';
    }
    else if (this.uploadType === 'External-Link') {
      NotificationTypeInt = '3';
      // Encode Link
      if(this.link !== '' && this.validationResult.isValid){
        try 
          {
            EncodeLink = btoa(unescape(encodeURIComponent('https://'+this.link)));
          } catch (e) {
            console.log('Encoding failed: Invalid input');
          }
        }
      }
    else {
      NotificationTypeInt = '0';
    }

    if (
      this.materialType === 'bulletin' ||
      this.materialType === 'training' ||
      this.materialType === 'info' ||
      this.materialType === 'sop'
    ) {
      this.hasFiles.file_name = 'Kosong'
      this.hasFiles.file_byte = this.Url
    }
    if (this.ownerType === 'User') {
      if (
        this.$v.title.$invalid ||
        this.byPosition3.length === 0 ||
        this.$v.message.$invalid ||
        this.$v.uploadType.$invalid ||
        this.$v.ownerUser.$invalid
      ) {
        return
      } else {
        if (this.uploadType === 'Material' && this.Url === '') {
          this.condition = true
          return
        }
        const dataToPost = {
          ownerType:
            this.ownerType.toLowerCase() === 'user'
              ? 'single'
              : this.ownerType.toLowerCase(),
          ownerId: this.ownerId,
          title: this.title,
          content: this.message,
          attachment:
            this.hasFiles.file_name !== '' ? this.hasFiles.file_upload : null,
          deletable: this.deletable,
          material:
            this.materialType === 'bulletin' ||
              this.materialType === 'training' ||
              this.materialType === 'info' ||
              this.materialType === 'sop'
              ? this.materialType.toLowerCase()
              : '',
          idMaterial:
            this.materialType === 'bulletin' ||
              this.materialType === 'training' ||
              this.materialType === 'info' ||
              this.materialType === 'sop'
              ? this.MaterialId
              : '',
          fileMaterial:
            this.materialType === 'bulletin' ||
              this.materialType === 'training' ||
              this.materialType === 'info' ||
              this.materialType === 'sop'
              ? this.Url
              : '',
          notificationType: NotificationTypeInt,
          externalLink: EncodeLink,
        }
        NotificationModule.postNotification(dataToPost)
        this.$root.$emit('bv::hide::modal', index, button)
      }
    } else {
      if (
        this.$v.title.$invalid ||
        this.byPosition3.length === 0 ||
        this.$v.message.$invalid ||
        this.$v.ownerType.$invalid ||
        this.$v.uploadType.$invalid
      ) {
        return
      } else {
        if (this.uploadType === 'Material' && this.Url === '') {
          return
        }
        const dataToPost = {
          ownerType: 'topic',
          ownerId: this.ownerId,
          title: this.title,
          content: this.message,
          attachment:
            this.hasFiles.file_name !== '' ? this.hasFiles.file_upload : '',
          deletable: this.deletable,
          material:
            this.materialType === 'bulletin' ||
              this.materialType === 'training' ||
              this.materialType === 'info' ||
              this.materialType === 'sop'
              ? this.materialType.toLowerCase()
              : '',
          idMaterial:
            this.materialType === 'bulletin' ||
              this.materialType === 'training' ||
              this.materialType === 'info' ||
              this.materialType === 'sop'
              ? this.MaterialId
              : '',
          fileMaterial:
            this.materialType === 'bulletin' ||
              this.materialType === 'training' ||
              this.materialType === 'info' ||
              this.materialType === 'sop'
              ? this.Url
              : '',
          notificationType: NotificationTypeInt,
          externalLink: EncodeLink,
        }
        NotificationModule.postNotification(dataToPost)
        this.$root.$emit('bv::hide::modal', index, button)
      }
    }
  }

  public resetAdd() {
    this.$v.ownerType.$reset()
    this.$v.uploadType.$reset()
    this.$v.materialType.$reset()
    this.$v.title.$reset()
    this.$v.ownerUser.$reset()
    this.$v.message.$reset()
    this.$v.Material.$reset()
    this.$v.Url.$reset()
    this.$v.Link.$reset()

    this.ownerType = ''
    this.byPosition = 'All'
    this.byGroup = 'All'
    this.byCity = 'All'
    this.byTeam = 'All'
    this.byDealerCode = 'All'
    this.byDealerName = 'All'
    this.byDealerArea = 'All'
    this.byPosition4 = 'All'
    this.byGroup4 = 'All'
    this.byCity4 = 'All'
    this.byTeam4 = 'All'
    this.byDealerCode4 = 'All'
    this.byDealerName4 = 'All'
    this.byDealerArea4 = 'All'
    this.Material = ''
    this.uploadType = ''
    this.materialType = ''
    this.MaterialId = ''
    this.Url = ''
    this.$v.byGuideMaterial = ''
    this.$v.byTrainingMaterial = ''
    this.$v.byInfoMaterial = ''
    this.$v.byBulletinMaterial = ''
    this.$v.byCity2 = ''
    this.$v.byGroup2 = ''
    this.$v.byPosition2 = ''
    this.$v.byDealerCode2 = ''
    this.$v.byDealerName2 = ''
    this.ownerUser = []
    this.title = ''
    this.arr = []
    this.max = 0
    this.message = ''
    this.InfoOptions = []
    this.TrainingOptions = []
    this.BulletinOptions = []
    this.GuideOptions = []
    this.byCity3 = ['All']
    this.byPosition3 = ['All']
    this.byGroup3 = ['All']
    this.byDealerCode3 = ['All']
    this.byDealerName3 = ['All']
    this.byDealerArea3 = ['All']
    this.byTeam3 = ['All']
    this.hasFiles = {
      file_name: '',
      file_byte: '',
      file_upload: null,
    }
    this.deletable = 'false'
    this.link = ''
  }
}
